module.exports = __webpack_public_path__ + "static/media/invite-friends.88648a06.svg";